module.exports = __webpack_public_path__ + "assets/email-black.d3774a17.svg";